module.exports = new __parcel__URL__("Druideskill_21.666035bc.png").toString();